import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type { Compliance, ComplianceLacking } from "@/types/compliance"

export const complianceQueries = {
  /** How much of its oversight the principal could evidence, and the gaps. */
  show: () =>
    queryOptions({
      queryKey: apiKey("/compliance"),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<Compliance>>(
          "/compliance",
          { signal }
        )

        return data
      },
    }),

  /** Everyone lacking one requirement, searchable by name. */
  gap: (key: string, search?: string) =>
    queryOptions({
      queryKey: apiKey(`/compliance/${encodeURIComponent(key)}`, { search }),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<ComplianceLacking>>(
          `/compliance/${encodeURIComponent(key)}`,
          { params: { search }, signal }
        )

        return data
      },
    }),
}
